class RoutineSkinFilter extends HTMLElement {
  connectedCallback() {
    this.chips = Array.from(this.querySelectorAll('[data-skin-value]'));
    this.wrapper =
      this.closest('.products-bundle')?.querySelector('[data-routine-bundles]') ||
      document.querySelector('[data-routine-bundles]');

    if (!this.wrapper || this.chips.length === 0) return;

    this.cards = Array.from(this.wrapper.querySelectorAll('[data-skin-types]'));
    this.chips.forEach((chip) => chip.addEventListener('click', (e) => this.onSelect(e.currentTarget)));
  }

  onSelect(chip) {
    const value = (chip.dataset.skinValue || 'all').toLowerCase();

    this.chips.forEach((c) => {
      const active = c === chip;
      c.classList.toggle('is-active', active);
      c.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    this.cards.forEach((card) => {
      if (value === 'all') {
        card.style.order = '';
        card.classList.remove('is-skin-dimmed');
        return;
      }
      const types = (card.dataset.skinTypes || '')
        .split(',')
        .map((t) => t.trim().toLowerCase())
        .filter(Boolean);
      const match = types.includes(value);
      card.style.order = match ? '0' : '1';
      card.classList.toggle('is-skin-dimmed', !match);
    });
  }
}

if (!customElements.get('routine-skin-filter')) {
  customElements.define('routine-skin-filter', RoutineSkinFilter);
}
